import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createBlock(_component_q_radio, {
    "keep-color": "",
    color: "brand",
    class: _normalizeClass(_ctx.classes)
  }, null, 8, ["class"]))
}